require('./notFoundViewContactCenter.scss');

// @ vendors
const React = require('react');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class NotFoundViewContactCenter extends React.Component {
    buildCustomMessageBox(){
        const title = formatText('notFound-title');
        const extraContent = <p className="not-found-view-cc__extra-content">{formatText('notFound-description')}</p>

        return (
            <div>
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    extraContent={extraContent}
                />
            </div>
        );
    }

    render() {
        return(
            <div>
                {this.buildCustomMessageBox()}
            </div>
        );
    }
}

module.exports = NotFoundViewContactCenter;
